import { render, staticRenderFns } from "./BillStatementList.vue?vue&type=template&id=55badfd5&scoped=true"
import script from "./BillStatementList.vue?vue&type=script&lang=js"
export * from "./BillStatementList.vue?vue&type=script&lang=js"
import style0 from "./BillStatementList.vue?vue&type=style&index=0&id=55badfd5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55badfd5",
  null
  
)

export default component.exports